import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { installmentsApi } from '../api/installments';
import { toast } from 'sonner';

export function useInstallments(params?: any) {
  return useQuery({
    queryKey: ['installments', params],
    queryFn: () => installmentsApi.getAll(params),
    staleTime: 1000 * 60 * 2,
  });
}

export function useInstallment(id: number) {
  return useQuery({
    queryKey: ['installments', id],
    queryFn: () => installmentsApi.getById(id),
    enabled: !!id && id > 0,
    staleTime: 1000 * 60 * 2,
  });
}

export function useInstallmentStats() {
  return useQuery({
    queryKey: ['installments', 'stats'],
    queryFn: () => installmentsApi.getStats(),
    staleTime: 1000 * 60 * 5,
  });
}

export function useCreateInstallment() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => installmentsApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['installments'] });
      toast.success('Contrato creado exitosamente');
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al crear el contrato');
    },
  });
}

export function useUpdateInstallment() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: any }) =>
      installmentsApi.update(id, data),
    onSuccess: (_data, { id }) => {
      queryClient.invalidateQueries({ queryKey: ['installments'] });
      queryClient.invalidateQueries({ queryKey: ['installments', id] });
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al actualizar el contrato');
    },
  });
}

export function useDeleteInstallment() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => installmentsApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['installments'] });
      toast.success('Contrato eliminado exitosamente');
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al eliminar el contrato');
    },
  });
}

export function useGenerateInstallmentPDF() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => installmentsApi.generatePDF(id),
    onSuccess: (_, id) => {
      queryClient.invalidateQueries({ queryKey: ['installments', id] });
      toast.success('PDF del contrato generado exitosamente');
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al generar el PDF');
    },
  });
}